export const RegisterCertificationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Ricerca Registro',
    path: '/sportello/ricerca-registro',
  },
];
